/**
 * @file check-selection-list.component.ts
 * @author Muhammad Hamza
 * @date 2023-01-28
 * @description Component for handling item selection in a list.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-check-selection-list',
  templateUrl: './check-selection-list.component.html',
  styleUrls: ['./check-selection-list.component.scss'],
})
export class CheckSelectionListComponent {
  @Input() itemList!: any[];
  @Input() icon: string = '';
  @Input() multiSelection: boolean = false;
  @Output() updateItemList = new EventEmitter<any>();
  CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  constructor() {}

  /**
   * @description Handles item selection based on whether it's a single or multiple selection.
   * @param id - The unique identifier of the selected item.
   * @return void
   */
  selectItem(id: string) {
    this.multiSelection
      ? (this.itemList = this.multipleSelection(id)) && this.submitList(id)
      : (this.itemList = this.singleSelection(id)) && this.submitList(id);
  }

  /**
   * @description Performs single selection in the item list.
   * @param id - The unique identifier of the selected item.
   * @return The updated item list.
   */
  singleSelection(id: string) {
    return this.itemList?.map((item: any) => {
      if (id === item.id) return { ...item, state: !item.state };
      else return { ...item, state: false };
    });
  }

  /**
   * @description Performs multiple selection in the item list.
   * @param id - The unique identifier of the selected item.
   * @return The updated item list.
   */
  multipleSelection(id: string) {
    return this.itemList?.map((item: any) => {
      if (id === item.id) return { ...item, state: !item.state };
      else return { ...item };
    });
  }

  /**
   * @description Emits the updated item list after selection.
   * @param id - The unique identifier of the selected item.
   * @return void
   */
  submitList(id: string) {
    this.updateItemList.emit({ itemList: this.itemList, selectedId: id });
  }
}
